import React from 'react';

class SearchResult extends React.Component {
  getData(data, section){
    var card = {}
    if(!data || !data[section]) {
      return [];
    }

    var m, propName;
    var prop;
    if(data[section].length > 0){
      for(var i = 0; i < data[section].length; i++){
        m = data[section][i];
        for(prop in m){
          propName = (data[section].length === 1) ? prop : prop + "_" + String(i);
          this.setProp(prop, m, propName, card);        
        }
      }      
    } else {
      m = data[section];
      for(prop in data[section]){
        propName = prop;
        this.setProp(prop, m, propName, card);        
      }      
    }

    return card;
  }

  setProp_(propName, source, target){
    return this.setProp(propName, source, propName, target);
  }

  setProp(propName, source, propTarget, target){
    if (source[propName]){
      target[propTarget] = source[propName];
      //delete source[propName];
      var data = target[propTarget];
      /*
      if(data.length > 10){
        data = data.substring(0, 10) + "...";  
      }
      */
      return `[${propTarget}:${data}]`;
    }
    
    return "";
  } 
}

export default (SearchResult);


// WEBPACK FOOTER //
// ./src/search/results/search_result.js